import { useRecordContext, useNotify, useRefresh, Button, Confirm } from 'react-admin';
import RemoveIcon from '@mui/icons-material/Remove';
import { useState } from 'react';
import { useApiMutation } from '../../utils/hooks';

interface RemoveGroupFromMachineButtonProps {
  groupId: number;
  groupName: string;
  onSuccess?: () => void;
}

export const RemoveGroupFromMachineButton = ({
  groupId,
  groupName,
  onSuccess,
}: RemoveGroupFromMachineButtonProps) => {
  const [open, setOpen] = useState(false);
  const machineRecord = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const { mutate, loading } = useApiMutation({
    method: 'DELETE',
    onSuccess: () => {
      notify('Group removed successfully', { type: 'success' });
      refresh();
      setOpen(false);
      if (onSuccess) {
        onSuccess();
      }
    },
  });

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = async () => {
    if (!machineRecord) return;
    await mutate(`/api/machines/${machineRecord.id}/groups/${groupId}`);
  };

  if (!machineRecord) return null;

  return (
    <>
      <Button
        label="Remove"
        onClick={handleClick}
        startIcon={<RemoveIcon />}
        color="error"
        size="small"
        disabled={loading}
      />
      <Confirm
        isOpen={open}
        title="Remove Group from Machine"
        content={`Are you sure you want to remove ${groupName} from machine ${machineRecord.serial}?`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
